function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Funnel"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 30,
  "data-height": 32,
  transform: "translate(1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.354 5.354l10.293 10.293c.195.195.354.577.354.854v15c0 .276.186.376.416.223l5.168-3.445c.23-.153.416-.501.416-.777v-11c0-.276.158-.658.354-.854l10.293-10.293c.195-.195.354-.578.354-.854v-4c0-.276-.224-.5-.5-.5h-27c-.276 0-.5.224-.5.5v4c0 .276.158.658.354.854z",
  className: "iconic-funnel-body iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  className: "iconic-funnel-rim iconic-property-accent iconic-property-stroke",
  fill: "none",
  d: "M.5.5h29"
}));

function SvgFunnelMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "funnel",
    className: "iconic iconic-funnel iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelMd);
export default __webpack_public_path__ + "static/media/funnel-md.33ae7baa.svg";
export { ForwardRef as ReactComponent };